import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './CustomFormFields.scss';
import { Input } from '@salesforce/design-system-react';


export const Percent = ({ enabled, required, label, fieldName, handleChange, error, defaultValue }) => {
  const [percent, setPercent] = useState(0);
  const [numFocused, setNumFocused] = useState(false);

  useEffect(() => {
    if (defaultValue) {
      setPercent(defaultValue);
    }
  }, [defaultValue]);

  const percentFormat = new Intl.NumberFormat('en-US');

  return (
    <div className='time-percent input-numeric'>
      <Input
        label={label}
        formatter={'currency'}
        type={numFocused ? 'number' : 'text'}
        className='time-percent-input input-numeric-input'
        disabled={ !enabled }
        required={ required }
        value={ numFocused ? percent : `${percentFormat.format(percent)} %` }
        errorText={error}
        name={fieldName}
        onChange={ (e) => {
          setPercent(e.target.value);
          handleChange(e, { fieldName, value: e.target.value });
        }}
        onBlur={ () => {
          setNumFocused(false);
        }}
        onFocus={ () => {
          setNumFocused(true);
        }}
      />
    </div>
  );
};

Percent.propTypes = {
  enabled: PropTypes.bool,
  required: PropTypes.bool,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  handleChange: PropTypes.func,
  error: PropTypes.string,
  defaultValue: PropTypes.number,
};
